import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import {
  Counter,
  Download as DownloadPlugin,
  Thumbnails,
  Zoom,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import { Button, IconButton } from "@mui/material";
import { East, West } from "@mui/icons-material";

const ImageViewer = (props) => {
  const { imageList, selectedIndex, visible, onClose, options, styles } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(selectedIndex);
  }, [selectedIndex]);

  return (
    <Lightbox
      index={selectedIndex}
      open={visible}
      close={onClose}
      on={{
        view: ({ index }) => setCurrentIndex(index),
      }}
      render={{
        iconPrev: () => (
          <IconButton className="bg-[#0000004d] text-white">
            {" "}
            <West className="text-white" />{" "}
          </IconButton>
        ),
        iconNext: () => (
          <IconButton className="bg-[#0000004d] text-white">
            {" "}
            <East className="text-white" />{" "}
          </IconButton>
        ),
      }}
      slides={imageList}
      styles={styles || {}}
      plugins={[DownloadPlugin, Zoom, Thumbnails, Counter]}
      toolbar={
        options && {
          buttons: [options(currentIndex), "close"],
        }
      }
    />
  );
};

export default React.memo(ImageViewer, (prevProps, nextProps) => {
  return (
    prevProps.imageList === nextProps.imageList &&
    prevProps.visible === nextProps.visible &&
    prevProps.selectedIndex === nextProps.selectedIndex &&
    prevProps.options === nextProps.options
  );
});
